module.exports = __webpack_public_path__ + "img/home.c8b8815c.svg";